// src/config.js
const API_BASE_URL = 'https://backend.petberrylb.com/api';
export { API_BASE_URL };

